module.exports = __webpack_public_path__ + "img/huawei_m5_lite_spacegray.3dbbbe93.png";